export default function Footer() {
  return (
    <footer className="sf-footer" data-testid="site-footer">
      <div className="sf-container" style={{ padding: "28px 24px", display: "flex", alignItems: "center", justifyContent: "space-between", gap: 16, flexWrap: "wrap" }}>
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <img
            src="/systemforge-logo.png"
            alt="SystemForge AI"
            data-testid="footer-logo-img"
            style={{ height: 28, width: 28, objectFit: "contain", opacity: 0.85 }}
          />
          <span className="sf-mono" style={{ fontSize: 12, letterSpacing: "0.12em", textTransform: "uppercase" }}>
            SystemForge AI
          </span>
        </div>
        <div className="sf-mono" style={{ fontSize: 12 }}>
          Audit Intelligence Engine &middot; Phase 1
        </div>
      </div>
    </footer>
  );
}
